import { ReactElement } from 'react'
import { useController } from 'react-hook-form'
import { TagsField } from '@ui2/forms'

interface Props {
  name: string
  disabled?: boolean
}

/** `TagsField` registered with the surrounding `Form2` (a `string[]` field). */
const FormTagsField = ({ name, disabled }: Props): ReactElement => {
  const {
    field: { value, onChange },
  } = useController({ name })

  return <TagsField value={value ?? []} onChange={onChange} disabled={disabled} />
}

export default FormTagsField
